import type { ServicesRepository } from '../domain/repositories/ServicesRepository.interface';
import { Service } from '../domain/entities/Service.entity';
import { servicesContent } from '../content/services.content';

/**
 * Static implementation of ServicesRepository. Validates every entry
 * through Service.create() so an invalid content edit fails loudly in
 * development/tests rather than silently rendering broken data.
 */
export class StaticServicesSource implements ServicesRepository {
  public async getAll(): Promise<Service[]> {
    return servicesContent.map((input) => Service.create(input));
  }

  public async getBySlug(slug: string): Promise<Service | null> {
    const match = servicesContent.find((input) => input.slug === slug);
    return match ? Service.create(match) : null;
  }
}
